import { DateRange } from "@mui/x-date-pickers-pro"
import { DateTime } from "luxon"

export const getInitialDateRange = (): DateRange<DateTime> => [
  DateTime.now().startOf("day"),
  DateTime.now().startOf("day")
]

export const getInitialMaxDate = (): DateTime =>
  DateTime.now().startOf("day").plus({ day: 4 })
